import { FIELD_TYPES } from "constants/template-field-type";
import ThemeConfig from "segments/core-configs/theme-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Animated Icons",
  fields: {
    ...ThemeConfig,
    iconsArray: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Icons",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          iconAsset: {
            type: FIELD_TYPES.GALLERY,
            label: "Icon",
            defaultImagesKeys: []
          },
          animationDuration: {
            type: FIELD_TYPES.TEXT,
            label: "Animation duration (seconds)"
          },
          initialOffset: {
            type: FIELD_TYPES.TEXT,
            label: "Initial offset (px)"
          }
        }
      }
    }
  }
};
